jQuery(document).ready(function ($) {
  console.log("JS enabled");

  // ===== Variables globales =====
  const mobileMenu = {
    burger: $(".burger"),
    mobileMenu: $(".mobilemenu"),
    mainPanel: $(".mobilemenu .panel.main-panel"),
    secondaryPanel: $(".mobilemenu .panel.secondary-panel"),
    mainPages: $(".mobilemenu .panel.main-panel .menu-item"),
    backButtons: $(
      ".mobilemenu .panel.secondary-panel button[data-trigger='back']"
    ),
  };

  // ===== Gestion de l'affichage de leads-quickaccess =====
  const leadsQuickaccess = $(".xefi-leads-quickaccess");
  const quickContact = $(".quickcontact");

  // Si quickContact n'existe pas, on affiche toujours leadsQuickaccess
  // Sinon, on le masque au chargement et on le gère au scroll
  if (!quickContact.length) {
    leadsQuickaccess.show();
  } else {
    leadsQuickaccess.hide();
  }

  // ===== Initialisation =====
  function initMobileMenu() {
    // Attacher les gestionnaires d'événements
    attachEventHandlers();
  }

  // ===== Gestionnaires d'événements =====
  function attachEventHandlers() {
    // Clic sur un élément du menu principal
    mobileMenu.mainPages.click(handleMainPageClick);

    // Clic sur le bouton retour (prêt pour l'implémentation future)
    mobileMenu.backButtons.click(handleBackButtonClick);

    // Ouverture/fermeture du menu selon l'état du burger
    mobileMenu.burger.click(function () {
      if ($(this).hasClass("close")) {
        // Si le burger a la classe close, on ferme le menu
        closeMobileMenu();
      } else {
        // Sinon, on ouvre le menu
        openMobileMenu();
      }
    });
  }

  // ===== Fonctions de gestion des événements =====
  function handleMainPageClick() {
    const trigger = $(this).data("trigger");

    // Activer le panel secondaire correspondant
    activateSecondaryPanel(trigger);

    // Faire glisser les panels vers la gauche
    slidePanelsLeft();
  }

  function handleBackButtonClick() {
    // Désactiver tous les panels secondaires
    deactivateAllSecondaryPanels();

    // Faire glisser les panels vers la droite (revenir à l'état initial)
    slidePanelsRight();
  }

  function openMobileMenu() {
    // Ajouter la classe close au burger pour le transformer en croix
    mobileMenu.burger.addClass("close");

    // Ici, vous pourriez ajouter du code pour afficher le menu mobile
    mobileMenu.mobileMenu.addClass("open");
  }

  function closeMobileMenu() {
    // Retirer la classe close du burger pour le remettre en état initial
    mobileMenu.burger.removeClass("close");

    // Remettre les panels dans leur état initial
    slidePanelsRight();
    deactivateAllSecondaryPanels();

    // Fermer le menu mobile
    mobileMenu.mobileMenu.removeClass("open");
  }

  // ===== Fonctions utilitaires =====
  function activateSecondaryPanel(trigger) {
    // Sélectionner le panel-sub correspondant au data-trigger
    const targetPanel = $(".panel-sub[data-target='" + trigger + "']");

    // Ajouter la classe "active" au panel ciblé
    targetPanel.addClass("active");

    // Retirer la classe active des autres panels
    $(".panel-sub").not(targetPanel).removeClass("active");
  }

  function deactivateAllSecondaryPanels() {
    // Retirer la classe "active" de tous les panels secondaires
    $(".panel-sub").removeClass("active");
  }

  function slidePanelsLeft() {
    // Ajouter la classe "slide-left" aux deux panels pour les décaler vers la gauche
    mobileMenu.mainPanel.addClass("slide-left");
    mobileMenu.secondaryPanel.addClass("slide-left");
  }

  function slidePanelsRight() {
    // Retirer la classe "slide-left" des deux panels pour les ramener à leur position initiale
    mobileMenu.mainPanel.removeClass("slide-left");
    mobileMenu.secondaryPanel.removeClass("slide-left");
  }

  // ===== Initialisation du menu mobile =====
  initMobileMenu();

  // ===== Gestion du scroll pour afficher leads-quickaccess =====
  $(window).scroll(function () {
    // On ne gère le scroll que si quickContact existe
    if (quickContact.length) {
      const quickContactOffset = quickContact.offset().top;
      const quickContactHeight = quickContact.outerHeight();
      const scrollPosition = $(window).scrollTop();

      // Si on a scrollé au-delà de quickcontact
      if (scrollPosition > quickContactOffset + quickContactHeight) {
        // Afficher leads-quickaccess avec une animation
        leadsQuickaccess.fadeIn(300);
      } else {
        // Masquer leads-quickaccess avec une animation
        leadsQuickaccess.fadeOut(300);
      }
    }
    // Si quickContact n'existe pas, leadsQuickaccess est déjà visible en permanence
  });
});
